import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id) {
  return yield oncallFetch("/api/oncall/partners/shifts-definitions/remove", {
    id,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/shifts-definitions/remove.js